import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectFirm, selectItems, selectParty } from '../Selectors/Master/ItemSelectors';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import Preview from '@mui/icons-material/Preview';
import PreviewIcon from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { adminStkInwMenu, StkInwMenu, UStkInwMenu } from '../TitleList';
import { fetchSktMemo, insertmanualStkInward, insertStkInwEntry } from '../../Store/PHPSlice/StkInw';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectStkMemo } from '../Selectors/Master/OutwardSelectors';


const ManualStkEntry = () => {

    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        firm: '',
        partyId: '',
        inwType: 'Manual Wise',
        stk_type: 'Manual Wise',
        memo: '',
        item: '',
        size: '',
        col: '',
        qnty: '',
        saleRt: '',
        purRt: '',
        totQty: '0',
        totprate: '0',
        totsrate: '0',
        totQty2: '0',
        totprate2: '0',
        totsrate2: '0',
        totamt: '0',
        totamt2: '0',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '',
        gst_type: 'no',
        gst: '5',
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '',
        discnt_val: '0',
        netamt: '',
        userId: userdata?.ID
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    
    const actionMap = {
        item: fetchItemData  // Add more mappings if needed
    };

    const [tableData, setTableData] = useState([]);
    const [multiItems, setMultiItems] = useState([]);
    const dispatch = useDispatch();
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);
    const partyList = useSelector(selectParty);
    const itemList = useSelector(selectItems);
    const firmlist = useSelector(selectFirm);
    const stkmemos = useSelector(selectStkMemo);

    useEffect(() => {

        dispatch(fetchPartyData());
        dispatch(fetchItemData());
        dispatch(fetchCompanyData());
        // dispatch(fetchSktMemo());
        fetchmanualStkmemo();
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (!userdata) return;


        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else if (userdata?.role === '2') {
                setActiveMenu(UStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }



        }
    }, []);

    useEffect(() => {
        if (tableData?.length > 0) {
            const prev_totamt = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totamt || 0), 0);
            const totamt = tableData?.reduce((acc, sum) => acc + parseFloat(sum.amt || 0), 0);
            const final_totamt = prev_totamt + totamt;
            const discnt_amt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(final_totamt));
            let grandtot = parseFloat(final_totamt) - discnt_amt;
            let cgst, igst, sgst;
            let gst_val = Math.round(grandtot * (parseFloat(formData.gst) / 100));
            let netamt = grandtot + parseFloat(formData.freight_ch) + parseFloat(formData.other_ch) + parseFloat(gst_val);
            if (formData.state_type === '1') {
                igst = gst_val;
            } else {
                const half_gst = Math.round(gst_val / 2).toFixed(2);
                cgst = half_gst;
                sgst = half_gst;
            }
            setFormData(prev => ({
                ...prev,
                totamt: final_totamt,
                discnt_amt: discnt_amt,
                grandtot: grandtot,
                totamt2: totamt,
                gst_val: gst_val,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: netamt
            }));
        }
    }, [tableData]);


    const fetchmanualStkmemo = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getManualSchlStkMemo2`);
            // console.log(response?.data);
            const memo = response?.data?.data;
            setFormData(prev => ({
                ...prev,
                memo: memo?.memo
            }));

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const gstField = [
        { label: 'GST(%)', name: 'gst' },
    ];
    const options_gst = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const stockType = [
        { value: 'Manual Wise', label: 'Manual Wise' },
        { value: 'Order Wise', label: 'Order Wise' },
    ];

    const opts_discnt_amt = [
        { value: 'percent', label: '%' },
        { value: 'rupees', label: 'Rs.' },
    ];

    const fields2 = [
        { label: 'Total Quantity', name: 'totQty', type: 'readOnly' },
        { label: 'Total Amount', name: 'totamt', type: 'readOnly' },
        { label: 'Freight Charges', name: 'freight_ch' },
    ];

    const fields21 = [
        // { label: 'Other Charges', name: 'other_ch' },
        { label: 'Total Quantity', name: 'totQty', type: 'readOnly' },
        { label: 'Gross Total', name: 'totamt', type: 'readOnly' }
    ];

    const fields4 = [
        { label: 'IGST', name: 'igst', type: 'readOnly' },
        { label: 'CGST', name: 'cgst', type: 'readOnly' },
        { label: 'SGST', name: 'sgst', type: 'readOnly' },
        { label: 'Grand Total', name: 'netamt', type: 'readOnly' }
    ];

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/stock-inward-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'item':
                if (value) {
                    const selectItem = itemList?.data?.find(item => item.ID === value)?.size;
                    const sizeArr = selectItem?.split(',');

                    const tableArr = sizeArr?.map((item) => {
                        return {
                            size: item,
                            color: '',
                            qty: 0,
                            srate: 0,
                            prate: 0,
                            amt: 0
                        }
                    });
                    setTableData(tableArr);
                }
                break;
            case 'partyId':
                if (value) {
                    const state_type = partyList?.data?.find(item => item.ID === formData.partyId)?.state_type;
                    setFormData(prev => ({
                        ...prev,
                        state_type: state_type
                    }));
                }
                break;
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    if (formData.discnt_type == 'percent') {
                        discnt_amt = Math.round((parseFloat(value) / 100) * totalAmount);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) / parseFloat(formData.gst));
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
            default:
                break;
        }

    };

    const handleRadioChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });

        if (event.target.value === 'yes') {
            const update_gross = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            // console.log(update_gross)
            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(formData.gst) / 100));
            if (formData.state_type == '1') {
                igst = cal_grand;
            } else {
                const half_grand = (cal_grand / 2).toFixed(2);
                cgst = half_grand;
                sgst = half_grand;
            }
            let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot
            }));

        }
        if (event.target.value === 'no') {
            const gross_tot = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10);
            const update_gross = parseInt(gross_tot, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(formData.gst) / 100));
            if (formData.state_type == '1') {
                igst = 0;
            } else {
                cgst = 0;
                sgst = 0;
            }
            let final_grand_tot = 0;

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot
            }));
        }
    };

    const handleInputComplete = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'gst':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch));

                    let igst = 0, cgst = 0, sgst = 0, netamt = 0;
                    if (formData.state_type == '1') {
                        igst = Math.round(grandtot2 / parseFloat(value));
                        netamt = igst + grandtot2;
                    } else {
                        const diff = Math.round(grandtot2 / parseFloat(value));
                        cgst = Math.round(diff / 2);
                        sgst = Math.round(diff / 2);
                        netamt = diff + grandtot2;
                    }

                    setFormData(prev => ({
                        ...prev,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: netamt
                    }));
                }
                break;

            case 'freight_ch':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let final_grand = grandtot2 + parseFloat(value) + other_ch;
                    setFormData(prev => ({
                        ...prev,
                        grandtot: final_grand
                    }));
                    if (formData.gst_type === 'yes') {
                        let gst_cal, igst, cgst, sgst;

                        gst_cal = Math.round(final_grand * (parseFloat(formData.gst) / 100));

                        if (formData.state_type == '1') {
                            igst = gst_cal;
                        } else {
                            cgst = Math.round(gst_cal / 2);
                            sgst = Math.round(gst_cal / 2);
                        }

                        let netamt = final_grand + gst_cal;
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst || 0,
                            cgst: cgst || 0,
                            sgst: sgst || 0,
                            netamt: netamt
                        }));

                    }
                }
                break;
            case 'other_ch':
                if (value) {

                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const freight_ch = formData.freight_ch !== "" ? parseFloat(formData.freight_ch) : 0;
                    const final_grand = grandtot2 + parseFloat(value) + freight_ch;

                    if (formData.gst_type === 'yes') {
                        let gst_cal = parseFloat((final_grand * (parseFloat(formData.gst) / 100)).toFixed(2));
                        let igst = 0, cgst = 0, sgst = 0;

                        if (formData.state_type === '1') {
                            igst = gst_cal;
                        } else {
                            cgst = parseFloat((gst_cal / 2).toFixed(2));
                            sgst = parseFloat((gst_cal / 2).toFixed(2));
                        }

                        let netamt = Math.round((final_grand + gst_cal))
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst,
                            cgst: cgst,
                            sgst: sgst,
                            netamt: netamt
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand
                        }));
                    }

                }
                break;

        };
    }


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
        switch (name) {
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    if (formData.discnt_type == 'percent') {
                        discnt_amt = Math.round((parseFloat(value) / 100) * totalAmount);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) * (parseFloat(formData.gst) / 100));
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
        };
    };

    const handleChange = (index, field, value) => {
        const updatedData = [...tableData];

        if (field === 'qty') {
            const prevQty = parseFloat(updatedData[index][field] || 0);
            const newQty = parseFloat(value || 0);
            const prate = parseFloat(updatedData[index].srate || 0);
            const amt = newQty * prate;
            // Update the quantity first
            updatedData[index][field] = newQty;
            updatedData[index].amt = amt;
            setTableData(updatedData);
            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totQty: parseFloat(prev.totQty) - prevQty + newQty,
                totQty2: parseFloat(prev.totQty2) - prevQty + newQty,
            }));
        }

        if (field === 'prate') {
            const prevPrate = parseFloat(updatedData[index][field] || 0);
            const newPrate = parseFloat(value || 0);
            const qty = parseFloat(updatedData[index].qty || 0);
            const amt = qty * newPrate;
            // Update the quantity first
            updatedData[index][field] = newPrate;
            updatedData[index].amt = amt;
            setTableData(updatedData);
            const totprate = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totprate), 0);
            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totprate: parseFloat(prev.totprate) - prevPrate + newPrate,
                totprate2: parseFloat(prev.totprate2) - prevPrate + newPrate,
            }));
        }

        if (field === 'srate') {
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const newQSrate = parseFloat(value || 0);
            const qty = parseFloat(updatedData[index].qty || 0);
            const amt = qty * newQSrate;
            // Update the quantity first
            updatedData[index][field] = newQSrate;
            updatedData[index].amt = amt;
            setTableData(updatedData);
            const totsrate = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totsrate), 0);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totsrate: parseFloat(prev.totsrate) - prevSrate + newQSrate,
                totsrate2: parseFloat(prev.totsrate2) - prevSrate + newQSrate,
            }));
        }

        if (field === 'color') {
            updatedData[index][field] = value;
            setTableData(updatedData);
        }
    };



    const handleMultiItems = () => {
        const itemNm = itemList?.data?.find(val => val.ID === formData.item)?.itemNm;
        const datas = {
            itemId: formData.item,
            itemNm: itemNm,
            info: tableData,
            totqty: formData.totQty2,
            totprate: formData.totprate2,
            totsrate: formData.totsrate2,
            totamt: formData.totamt2
        };
        setMultiItems(prev => [...prev, datas]);
        setFormData(prev => ({
            ...prev,
            item: '',
            totQty2: '0',
            totprate2: '0',
            totsrate2: '0',
            totamt2: '0'
        }));
        setTableData([]);
    };

    // console.log(multiItems)

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    // console.log(multiItems);

    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data || [],
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Party',
            id: 'partyId',
            options: partyList?.data?.filter(item => item.partyType === '2') || [],
            value: formData.partyId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Item',
            id: 'item',
            options: itemList?.data || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
    ];

    const handleItemNew = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };


    const dropdownManual = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data || [],
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Item',
            id: 'item',
            options: itemList?.data || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('item'),
            handleDropdownClose: () => handleDropdownClose('item'),
        }
    ];

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    const handleRemoveSelected = () => {
        const totamt = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totamt), 0);
        const totqty = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
        setFormData(prev => ({
            ...prev,
            totamt: totamt,
            totQty: totqty
        }));
        setMultiItems(prevFormArray =>
            prevFormArray.filter((_, index) => !selectedRows.has(index))
        );
        setSelectedRows(new Set()); // Clear selection after removal
    };

    function convertIntoOneObject(formData, multiItems) {
        const totsrate = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totsrate || 0), 0);
        const data = {
            dt: formData.dt,
            memo: formData.memo,
            firmId: formData.firm,
            multiItems: multiItems,
            totamt: formData.totamt,
            totqty: formData.totQty,
            userId: formData.userId,
            stk_type: formData.stk_type,
            totsrate: totsrate
        };
        return data;
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.firm === '') {
            alert('Please Select Firm.');
            return; // Stop form submission
        }
        // if (formData.inwType === 'Order Wise' && formData.partyId === '') {
        //     alert('Select Party');
        //     return; // Stop form submission
        // }


        const finalObj = convertIntoOneObject(formData, multiItems);
        // console.log(finalObj);

        dispatch(insertmanualStkInward(finalObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Stock Inward Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };
    return (
        <>
            <Titlebar data={activeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Manual Stock Inward</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No', name: 'memo', type: 'readOnly' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <RadioComponent
                                    label='Inward Type'
                                    name='inwType'
                                    value={formData.inwType}
                                    options={stockType}
                                    onChange={handleRadioChange}
                                    isDesktop={true}
                                />

                                {
                                    formData.inwType === 'Order Wise' && dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                } */}

                                {
                                    formData.inwType === 'Manual Wise' && dropdownManual?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {/* <RadioComponent
                                    label='GST'
                                    name='gst_type'
                                    value={formData.gst_type}
                                    options={options_gst}
                                    onChange={handleRadioChange}
                                    isDesktop={true}
                                /> */}

                                {/* {formData.gst_type === 'yes' ?

                                    <>
                                        {gstField.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                handleInputComplete={handleInputComplete}
                                            />
                                        ))}
                                    </>
                                    : (
                                        <Grid item xs={12} md={6}>
                                        </Grid>
                                    )
                                }  */}


                                {/* {fields2.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))} */}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor="discnt_amt">Discount Amount:</InputLabel>
                                            <RadioGroup row name="discnt_type" value={formData.discnt_type} onChange={handleRadioChange}>
                                                {opts_discnt_amt.map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        value={option.value}
                                                        control={<Radio />}
                                                        label={option.label}
                                                    />
                                                ))}
                                              
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                                <TextField
                                                    id="discnt_val"
                                                    name="discnt_val"
                                                    value={formData.discnt_val}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.inputs }}
                                                    sx={inputNumbersmall}
                                                />
                                                <TextField
                                                    id="discnt_amt"
                                                    name="discnt_amt"
                                                    value={formData.discnt_amt}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input, readOnly: true }}
                                                    sx={inputStyle11}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {fields21.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                {/* {formData.gst_type === 'yes' &&
                                    <>
                                        {
                                            fields4.map((field) => (
                                                <DateInputComponent
                                                    key={field.name}
                                                    formData={formData}
                                                    handleDateChange={handleDateChange}
                                                    handleInputChange={handleInputChange}
                                                    styled={styled}
                                                    inputStyles={inputStyles}
                                                    isDesktop={isDesktop}
                                                    field={field}
                                                />
                                            ))
                                        }
                                    </>

                                } */}

                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableBody>

                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>

                                                        {tableData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.size}</TableCell>
                                                        ))}

                                                    </TableRow>


                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Color</TableCell>

                                                        {tableData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <input type="text"
                                                                    value={item.color || ''}
                                                                    name='color'
                                                                    onChange={(e) => handleChange(index, 'color', e.target.value)}
                                                                    style={{ height: '25px', width: '60px' }}
                                                                />
                                                            </TableCell>
                                                        ))}

                                                    </TableRow>
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>

                                                        {tableData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <input type="text"
                                                                    value={item.qty || ''}
                                                                    name='qty'
                                                                    onChange={(e) => handleChange(index, 'qty', e.target.value)}
                                                                    style={{ height: '25px', width: '60px' }}
                                                                />
                                                            </TableCell>
                                                        ))}

                                                    </TableRow>


                                                    {/* <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Purchase Price</TableCell>

                                                        {tableData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <input type="text"
                                                                    value={item.prate || ''}
                                                                    name='prate'
                                                                    onChange={(e) => handleChange(index, 'prate', e.target.value)}
                                                                    style={{ height: '25px', width: '60px' }}
                                                                />
                                                            </TableCell>
                                                        ))}

                                                    </TableRow> */}
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sale Price</TableCell>

                                                        {tableData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <input type="text"
                                                                    value={item.srate || ''}
                                                                    name='srate'
                                                                    onChange={(e) => handleChange(index, 'srate', e.target.value)}
                                                                    style={{ height: '25px', width: '60px' }}
                                                                />
                                                            </TableCell>
                                                        ))}

                                                    </TableRow>
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Amt</TableCell>

                                                        {tableData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                {item.amt}
                                                            </TableCell>
                                                        ))}

                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>


                                        <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <Button variant="contained" color="primary" onClick={handleMultiItems}>Add</Button>

                                        </Grid>
                                    </>
                                }
                                <Button variant="contained" color="primary" onClick={handleRemoveSelected}>Delete</Button>
                                {multiItems.length > 0 &&
                                    <TableContainer
                                        style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}
                                    >
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Amt.</TableCell>
                                                    {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Sale Rate</TableCell> */}
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>View</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {multiItems.length > 0
                                                    ? multiItems?.map((form, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows?.has(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totqty}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totamt}</TableCell>
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totsrate}</TableCell> */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(form)} />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                    : ''}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default ManualStkEntry;
